module.exports = __webpack_public_path__ + "img/pp-58.765ed8be.jpg";